const sections = [
  {
    text: "Your data at a glance",
    link: "/your-data-at-a-glance",
    cta: "Find out more",
    className: "data_glance",
  },
  {
    text: "Privacy policy",
    heading: "Our privacy policy",
    link: "/privacy-policy",
    cta: "Find out more",
    className: "privacy_policy",
  },
  {
    text: "Cookie policy",
    heading: "Our cookie policy",
    link: "/cookie-policy",
    cta: "Find out more",
    className: "cookie_policy",
  },
  {
    text: "How to keep your data safe",
    link: "/how-to-keep-your-data-safe",
    cta: "Find out more",
    className: "data_safety",
  },
  {
    text: "Your rights",
    link: "/your-rights",
    cta: "Find out more",
    className: "your_rights",
  },
  {
    text: "FAQ",
    link: "/faq",
    cta: "Find out more",
    className: "faq",
  },
];

module.exports = {
  sections,
  routerBase: "",
  marketingPermissionsUrl: "https://permissions.sainsburys.co.uk/",
};



// WEBPACK FOOTER //
// ./src/config/index.js